<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',
};
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Marcellus+SC&display=swap');

html, body,h2, h1, h3, h4 {
  font-family: 'Marcellus SC', serif;
}
</style>
